var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.57,
    height: 69.552,
    viewBox: "0 0 54.57 69.552",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(-103.369 -683.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    className: "cls-1",
    d: "M98.058,892.353a1.381,1.381,0,0,1-1.32-.98l-6.981-23.144H63.274V840.881a1.378,1.378,0,1,1,2.755,0v24.593H91.8l7.574,25.1a1.381,1.381,0,0,1-1.32,1.777",
    transform: "translate(58.502 -142.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    className: "cls-1",
    d: "M21.882,930.37A21.871,21.871,0,0,1,14.511,887.9a1.378,1.378,0,1,1,.931,2.594,19.119,19.119,0,1,0,25.567,17.989c-.014-.17-.021-.3-.023-.425a1.377,1.377,0,0,1,1.351-1.4,1.311,1.311,0,0,1,1.4,1.352l.023.477A21.907,21.907,0,0,1,21.882,930.37",
    transform: "translate(103.369 -176.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    className: "cls-1",
    d: "M89.736,864.628H82.047a1.975,1.975,0,0,1-1.975-1.975V843.161a1.975,1.975,0,0,1,1.975-1.975h7.689a1.975,1.975,0,0,1,1.975,1.975v19.493a1.975,1.975,0,0,1-1.975,1.975",
    transform: "translate(46.591 -143.903)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    className: "cls-1",
    d: "M86.9,805.609a5.307,5.307,0,1,1,5.25-5.306,5.284,5.284,0,0,1-5.25,5.306m0-8.113a2.807,2.807,0,1,0,2.75,2.806A2.781,2.781,0,0,0,86.9,797.5",
    transform: "translate(45.469 -111.15)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDa);
export default __webpack_public_path__ + "static/media/DA.8c75e5d7.svg";
export { ForwardRef as ReactComponent };